import FileModel from './globals/FileModel';

export default class StandsSecurityAttestationZipModel extends FileModel {
  static get path() {
    return '/backend/stands_security_attestation';
  }
}
